import Cartesian from './data-visualizations/Cartesian';
// import CartesianExample from "./data-visualizations/CartesianExample";
import Scatter from './data-visualizations/Scatter';
import Bar from './data-visualizations/Bar';
import Column from './data-visualizations/Column';
import RatioBar from './data-visualizations/RatioBar.json';
import HealthRatioBar from './data-visualizations/HealthRatioBar.json';
import Pie from './data-visualizations/Pie';
import Sunburst from './data-visualizations/Sunburst';
import Gauge from './data-visualizations/Gauge';
import Table from './data-visualizations/Table';
import HeatMap from './data-visualizations/HeatMap';
import HealthPie from './data-visualizations/HealthPie';
import Traffic from './data-visualizations/TrafficLight';
import EmptyBox from './data-visualizations/EmptyBox';
import StackedCartesian from './data-visualizations/StackedCartesian';

import BasicElement from './html/BasicElement';
import Counter from './widgets/Counter';
import CustomLink from './html/CustomLink';
import List from './html/List';
import ListItem from './html/ListItem';
import NestedElements from './html/NestedElements';
import NestedExample1 from './html/NestedExample1';
import NestedExample2 from './html/NestedExample2';
import OrderedList from './html/OrderedList';
import Test from './html/Test';
import MapArray from './html/MapArray';
import ProductResource from './html/ProductResource.json';

import Data from './data-sources/data';
import Jsonata from './data-sources/jsonata';
// import ChuckJokes from "./data-sources/rest";
import UQLDatasource from './data-sources/uql';

import GridContainerNoReflow from './layouts/GridContainer';
import GridContainerWithReflow from './layouts/GridContainerWithReflow';
import CardWithTitle from './widgets/CardWithTitle';
import CardWithEditProps from './widgets/CardWithEditProps';
import { SingleValue, SingleValueNumber, SingleValueString, SingleValueArray } from './widgets/SingleValue';
import TimerangeSelect from './widgets/TimerangeSelect.json';
// import USMap from "./widgets/USMap";
import Graph from './data-visualizations/Graph';
import StatusCard from './widgets/StatusCard.json';
import HealthStatusCard from './widgets/HealthStatusCard.json';
import HealthCounts from './widgets/HealthCounts';
import ResponsiveGridLayout from './layouts/ResponsiveGridLayout';
import GridLayout from './layouts/GridLayout';
import ProductResourcesCard from './widgets/ProductResourcesCard.json';

import ComponentList from './ComponentList';
import MultipleCounters from './widgets/MultipleCounters';
import Events from './html/Events';
// import MultiSelectLocalDemo from "./html/MultiSelectLocalDemo";
// import MultiSelectGlobalDemo from "./html/MultiSelectGlobalDemo";
import ConditionalIf from './html/ConditionalIf';
import ConditionalSwitch from './html/ContionalSwitch';
import CellTextColor from './html/CellTextColor.json';
import CellBackgroundColor from './html/CellBackgroundColor.json';
import CellHealthIcons from './html/CellHealthIcons.json';
import CellSparkline from './html/CellSparkline.json';
import FavoritesCard from './widgets/FavoritesCard.json';
import RecentlyVisitedCard from './widgets/RecentlyVisitedCard.json';

import SimpleChart from './widgets/SimpleHighcharts';
import editorTemplates from '../../src/modules/components/widget/visualizationTypes';

// csaas widgets
import csaasHealthStatus from './csaas/visualizations/HealthStatus.json';
import csaasHealthStatusWidget from './csaas/HealthStatusWidget.json';

import csaasTimeSeries from './csaas/visualizations/TimeSeries.json';
import csaasTimeSeriesWidget from './csaas/TimeSeriesWidget.json';

import csaasPie from './csaas/visualizations/Pie.json';
import csaasPieWidget from './csaas/PieWidget.json';

import csaasGauge from './csaas/visualizations/Gauge.json';
import csaasGaugeWidget from './csaas/GaugeWidget.json';

import csaasMetricValue from './csaas/visualizations/MetricValue.json';
import csaasMetricValueWidget from './csaas/MetricValueWidget.json';

import csaasEventList from './csaas/visualizations/EventList.json';
import csaasEventListWidget from './csaas/EventListWidget.json';

import csaasApmApplicationsFilter from './csaas/filters/apmAppsFilter.json';
import csaasApmBTsFilter from './csaas/filters/apmBTsFilter.json';
import csaasApmTiersFilter from './csaas/filters/apmTiersFilter.json';
import csaasApmNodesFilter from './csaas/filters/apmNodesFilter.json';
import btMetricSelector from './csaas/filters/btMetricSelector.json';
import tierMetricSelector from './csaas/filters/tierMetricSelector.json';
import nodeMetricSelector from './csaas/filters/nodeMetricSelector.json';
import overallMetricSelector from './csaas/filters/overallMetricSelector.json';

export default [
  // Data Visualizations
  Cartesian,
  // CartesianExample,
  Scatter,
  Bar,
  Column,
  RatioBar,
  HealthRatioBar,
  Pie,
  Sunburst,
  Gauge,
  Table,
  Graph,
  HeatMap,
  HealthPie,
  Traffic,
  EmptyBox,
  StackedCartesian,

  // html
  BasicElement,
  NestedElements,
  OrderedList,
  ListItem,
  // NestedExample1,
  // NestedExample2,
  Counter,
  MultipleCounters,
  CustomLink,
  Test,
  MapArray,
  Events,
  ProductResource,
  // MultiSelectLocalDemo,
  // MultiSelectGlobalDemo,
  ConditionalIf,
  ConditionalSwitch,
  CellTextColor,
  CellBackgroundColor,
  CellHealthIcons,
  CellSparkline,

  // Widgets
  SingleValue,
  SingleValueNumber,
  SingleValueString,
  SingleValueArray,
  TimerangeSelect,
  List,

  CardWithTitle,
  CardWithEditProps,
  HealthCounts,
  StatusCard,
  HealthStatusCard,
  ProductResourcesCard,
  // Data Sources
  Data,
  Jsonata,
  // ChuckJokes,
  UQLDatasource,

  // Layouts
  GridContainerNoReflow,
  GridContainerWithReflow,
  ResponsiveGridLayout,
  GridLayout,

  // Homepage cards
  FavoritesCard,
  RecentlyVisitedCard,

  // Component List
  ComponentList,

  SimpleChart,

  // Editor
  ...editorTemplates,

  // csaas widgets and filters
  csaasHealthStatus,
  csaasHealthStatusWidget,

  csaasTimeSeries,
  csaasTimeSeriesWidget,

  csaasPie,
  csaasPieWidget,

  csaasGauge,
  csaasGaugeWidget,

  csaasMetricValue,
  csaasMetricValueWidget,

  csaasEventList,
  csaasEventListWidget,

  csaasApmApplicationsFilter,
  csaasApmBTsFilter,
  csaasApmTiersFilter,
  csaasApmNodesFilter,
  btMetricSelector,
  tierMetricSelector,
  nodeMetricSelector,
  overallMetricSelector,
];
